import { useState } from "react";
import { gold, w } from "../constants";
import { Card } from "../components";
import { initPdf, downloadExcel } from "./exportHelpers";
function DownloadModal({ onPdf, onExcel, onClose }) {
  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000 }}>
      <div style={{ background:"#fff",borderRadius:16,padding:28,width:"100%",maxWidth:360,margin:"0 16px" }}>
        <h2 style={{ fontSize:17,fontWeight:500,margin:"0 0 6px",color:"#1a1a1a" }}>Download your results</h2>
        <p style={{ fontSize:13,color:"#555",margin:"0 0 20px" }}>Choose your preferred format:</p>
        <button onClick={onPdf} style={{ width:"100%",padding:"12px",borderRadius:10,border:"none",background:"#A0845C",color:"#fff",fontSize:14,fontWeight:500,cursor:"pointer",marginBottom:10 }}>📄 Download PDF</button>
        <button onClick={onExcel} style={{ width:"100%",padding:"12px",borderRadius:10,border:"0.5px solid rgba(0,0,0,0.1)",background:"transparent",color:"#1a1a1a",fontSize:14,cursor:"pointer",marginBottom:10 }}>📊 Download Excel</button>
        <button onClick={onClose} style={{ width:"100%",padding:"10px",borderRadius:10,border:"0.5px solid rgba(0,0,0,0.1)",background:"transparent",color:"#555",fontSize:13,cursor:"pointer" }}>Cancel</button>
      </div>
    </div>
  );
}

const HABITS = [
  { id:"exercise", label:"Exercise", icon:"🏃", color:"#E02424", desc:"Did you exercise today?", examples:"Walk, gym, sport, yoga, cycling" },
  { id:"nutrition", label:"Nutrition", icon:"🥗", color:"#057A55", desc:"Did you eat well today?", examples:"Balanced meals, no junk, right portions" },
  { id:"sleep", label:"Sleep", icon:"😴", color:"#1A56DB", desc:"Did you get enough sleep?", examples:"7-9 hours, good quality, consistent time" },
  { id:"hydration", label:"Hydration", icon:"💧", color:"#0694A2", desc:"Did you drink enough water?", examples:"8 glasses, stayed hydrated all day" },
];

const DAYS = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];

const weekKey = date => { const d=new Date(date);d.setHours(0,0,0,0);d.setDate(d.getDate()-d.getDay()+1);return d.toISOString().slice(0,10); };
const getCurrentWeekDates = () => { const today=new Date();const mon=new Date(today);mon.setDate(today.getDate()-today.getDay()+1);return DAYS.map((_,i)=>{ const d=new Date(mon);d.setDate(mon.getDate()+i);return d.toISOString().slice(0,10); }); };

function exportFitnessPdf(tracker, userName) {
  const p = initPdf();
  p.addHeader("Personal Fitness Tracker", userName);
  const weeks = Object.keys(tracker).sort().reverse();
  if(!weeks.length){ p.body("No fitness data recorded yet."); p.addFooters(); p.doc.save(`fitness-tracker-${new Date().toISOString().slice(0,10)}.pdf`); return; }
  weeks.forEach(wk => {
    const wd = tracker[wk];
    const wkDates = [];
    const mon = new Date(wk);
    for(let i=0;i<7;i++){const d=new Date(mon);d.setDate(mon.getDate()+i);wkDates.push(d.toISOString().slice(0,10));}
    let done=0;
    HABITS.forEach(h=>{ done+=(wd[h.id]||[]).filter(d=>wkDates.includes(d)).length; });
    const score = Math.round((done/28)*100);
    p.heading2(`Week of ${wk} — ${score}%`);
    HABITS.forEach(h=>{ const count=(wd[h.id]||[]).filter(d=>wkDates.includes(d)).length; p.body(`${h.label}: ${count}/7 days`, 4); });
    p.space(4);
  });
  p.addFooters();
  p.doc.save(`fitness-tracker-${new Date().toISOString().slice(0,10)}.pdf`);
}

function exportFitnessExcel(tracker, userName) {
  const data = [
    ["My Self-Management Framework — Personal Fitness Tracker"],
    [`Name: ${userName}`, `Exported: ${new Date().toLocaleDateString("en-IN")}`],
    [],
    ["Week","Exercise","Nutrition","Sleep","Hydration","Weekly Score"],
  ];
  Object.keys(tracker).sort().reverse().forEach(wk => {
    const wd = tracker[wk];
    const wkDates = [];
    const mon = new Date(wk);
    for(let i=0;i<7;i++){const d=new Date(mon);d.setDate(mon.getDate()+i);wkDates.push(d.toISOString().slice(0,10));}
    let done=0;
    const counts = HABITS.map(h=>{ const c=(wd[h.id]||[]).filter(d=>wkDates.includes(d)).length;done+=c;return c; });
    data.push([wk,...counts,`${Math.round((done/28)*100)}%`]);
  });
  downloadExcel([{name:"Fitness Tracker",data}],`fitness-tracker-${new Date().toISOString().slice(0,10)}.xlsx`);
}

function WeekView({ weekData, weekDates, onToggle, onBack, isHistory }) {
  const today = new Date().toISOString().slice(0,10);
  const weekScore = () => { let total=0;let possible=0;HABITS.forEach(h=>{weekDates.forEach(d=>{possible++;if(weekData?.[h.id]?.includes(d))total++;});});return possible>0?Math.round((total/possible)*100):0; };

  return (
    <div>
      <button onClick={onBack} style={{ fontSize:13,color:w.text2,background:"transparent",border:"none",cursor:"pointer",marginBottom:16,padding:0 }}>← Back</button>
      <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16 }}>
        <h2 style={{ fontSize:17,fontWeight:500,margin:0,color:w.text }}>Week of {weekDates[0]}</h2>
        <div style={{ textAlign:"right" }}><div style={{ fontSize:22,fontWeight:500,color:gold }}>{weekScore()}%</div><div style={{ fontSize:11,color:w.text3 }}>weekly score</div></div>
      </div>
      <div style={{ display:"flex",gap:4,marginBottom:6,paddingLeft:100 }}>
        {DAYS.map((d,i)=>{ const isToday=weekDates[i]===today;return <div key={d} style={{ flex:1,textAlign:"center",fontSize:11,fontWeight:isToday?500:400,color:isToday?gold:w.text3 }}>{d}</div>; })}
      </div>
      {HABITS.map(h=>{
        const completed=weekData?.[h.id]||[];
        return (
          <div key={h.id} style={{ display:"flex",gap:4,marginBottom:10,alignItems:"center" }}>
            <div style={{ width:96,display:"flex",alignItems:"center",gap:8,flexShrink:0 }}>
              <span style={{ fontSize:14 }}>{h.icon}</span>
              <span style={{ fontSize:12,color:w.text2,fontWeight:500 }}>{h.label}</span>
            </div>
            {weekDates.map((date,di)=>{
              const done=completed.includes(date);const isPast=date<=today;const isTodayCell=date===today;
              return (
                <button key={di} onClick={()=>!isHistory&&isPast&&onToggle(h.id,date)} disabled={isHistory||!isPast} style={{ flex:1,height:34,borderRadius:6,cursor:(!isHistory&&isPast)?"pointer":"default",border:`0.5px solid ${done?h.color:isTodayCell?gold:w.border}`,background:done?h.color:isTodayCell?`${gold}10`:"transparent",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,color:done?"#fff":w.text3 }}>
                  {done?"✓":""}
                </button>
              );
            })}
            <div style={{ width:36,textAlign:"right",fontSize:11,color:h.color,fontWeight:500 }}>{Math.round((completed.filter(d=>weekDates.includes(d)).length/7)*100)}%</div>
          </div>
        );
      })}
      <div style={{ marginTop:16,background:w.bg2,borderRadius:10,padding:"12px 16px" }}>
        <div style={{ display:"flex",justifyContent:"space-between",marginBottom:8 }}><span style={{ fontSize:13,fontWeight:500,color:w.text }}>Week score</span><span style={{ fontSize:15,fontWeight:500,color:gold }}>{weekScore()}%</span></div>
        <div style={{ height:8,background:w.bg3,borderRadius:4,overflow:"hidden" }}><div style={{ height:"100%",width:`${weekScore()}%`,background:gold,borderRadius:4 }} /></div>
      </div>
    </div>
  );
}

export default function FitnessModule({ moduleData, onSave, onBack, userName }) {
  const [view, setView] = useState("home");
  const [historyWeek, setHistoryWeek] = useState(null);
  const [showDownload, setShowDownload] = useState(false);
  const tracker = moduleData?.tracker||{};
  const targets = moduleData?.targets||Object.fromEntries(HABITS.map(h=>[h.id,5]));
  const currentWeek = weekKey(new Date());
  const currentWeekDates = getCurrentWeekDates();
  const currentData = tracker[currentWeek]||{};

  const toggle = (habitId, date) => {
    const wk = weekKey(new Date(date));
    const prev = tracker[wk]?.[habitId]||[];
    const updated = prev.includes(date)?prev.filter(d=>d!==date):[...prev,date];
    onSave({ ...moduleData, tracker:{ ...tracker, [wk]:{ ...(tracker[wk]||{}), [habitId]:updated } } });
  };

  const saveTarget = (habitId, val) => { onSave({ ...moduleData, targets:{ ...targets, [habitId]:parseInt(val)||5 } }); };

  const allWeeks = Object.keys(tracker).sort().reverse().filter(k=>k!==currentWeek);

  const weekScore = (wkData, wkDates) => { let total=0;let possible=0;HABITS.forEach(h=>{(wkDates||Array(7).fill(null)).forEach(()=>{possible++;if((wkData?.[h.id]||[]).length>0)total++;});});return possible>0?Math.round((total/possible)*100):0; };

  if(view==="current") return <WeekView weekData={currentData} weekDates={currentWeekDates} onToggle={toggle} onBack={()=>setView("home")} isHistory={false} />;
  if(view==="history"&&historyWeek) {
    const hwDates=[];const mon=new Date(historyWeek);
    for(let i=0;i<7;i++){const d=new Date(mon);d.setDate(mon.getDate()+i);hwDates.push(d.toISOString().slice(0,10));}
    return <WeekView weekData={tracker[historyWeek]} weekDates={hwDates} onToggle={()=>{}} onBack={()=>setView("home")} isHistory={true} />;
  }

  const todayScore = () => { const today=new Date().toISOString().slice(0,10);return HABITS.filter(h=>(currentData[h.id]||[]).includes(today)).length; };

  return (
    <div>
      {showDownload&&<DownloadModal onPdf={()=>{exportFitnessPdf(tracker,userName||"User");setShowDownload(false);}} onExcel={()=>{exportFitnessExcel(tracker,userName||"User");setShowDownload(false);}} onClose={()=>setShowDownload(false)} />}
      <button onClick={onBack} style={{ fontSize:13,color:w.text2,background:"transparent",border:"none",cursor:"pointer",marginBottom:16,padding:0 }}>← Back to Modules</button>
      <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8 }}>
        <div style={{ display:"flex",alignItems:"center",gap:12 }}>
          <div style={{ width:40,height:40,borderRadius:10,background:`${gold}20`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20 }}>💪</div>
          <div><h2 style={{ fontSize:18,fontWeight:500,margin:0,color:w.text }}>Personal Fitness Tracker</h2><p style={{ fontSize:13,color:w.text3,margin:0 }}>Weekly habit tracker</p></div>
        </div>
        {Object.keys(tracker).length>0&&<button onClick={()=>setShowDownload(true)} style={{ padding:"6px 14px",borderRadius:8,border:`0.5px solid ${gold}`,background:"transparent",color:gold,fontSize:12,cursor:"pointer",fontWeight:500 }}>Download ↓</button>}
      </div>

      <div style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,margin:"20px 0" }}>
        {HABITS.map(h=>{ const today=new Date().toISOString().slice(0,10);const done=(currentData[h.id]||[]).includes(today);
          return <button key={h.id} onClick={()=>toggle(h.id,today)} style={{ background:done?h.color:w.bg,border:`0.5px solid ${done?h.color:w.border}`,borderRadius:12,padding:"14px 10px",textAlign:"center",cursor:"pointer" }}>
            <div style={{ fontSize:20,marginBottom:6 }}>{h.icon}</div>
            <div style={{ fontSize:12,fontWeight:500,color:done?"#fff":w.text }}>{h.label}</div>
            <div style={{ fontSize:10,color:done?"rgba(255,255,255,0.8)":w.text3,marginTop:4 }}>{done?"Done today":"Tap to log"}</div>
          </button>; })}
      </div>

      <div style={{ background:w.bg2,borderRadius:10,padding:"12px 16px",marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center" }}>
        <div><p style={{ fontSize:13,fontWeight:500,color:w.text,margin:"0 0 2px" }}>Today</p><p style={{ fontSize:12,color:w.text3,margin:0 }}>{todayScore()}/4 habits done</p></div>
        <button onClick={()=>setView("current")} style={{ fontSize:12,padding:"6px 14px",borderRadius:8,border:`0.5px solid ${gold}`,background:"transparent",color:gold,cursor:"pointer" }}>View full week</button>
      </div>

      <Card>
        <h3 style={{ fontSize:14,fontWeight:500,color:w.text,margin:"0 0 12px" }}>Weekly targets</h3>
        {HABITS.map(h=>(
          <div key={h.id} style={{ display:"flex",alignItems:"center",gap:12,marginBottom:10 }}>
            <span style={{ fontSize:14 }}>{h.icon}</span>
            <span style={{ flex:1,fontSize:13,color:w.text2 }}>{h.label}</span>
            <span style={{ fontSize:12,color:w.text3 }}>Target:</span>
            <select value={targets[h.id]||5} onChange={e=>saveTarget(h.id,e.target.value)} style={{ border:`0.5px solid ${w.border}`,borderRadius:6,padding:"4px 8px",fontSize:13,background:w.bg2,color:w.text }}>
              {[1,2,3,4,5,6,7].map(n=><option key={n} value={n}>{n}x/week</option>)}
            </select>
          </div>
        ))}
      </Card>

      {allWeeks.length>0&&(
        <div>
          <h3 style={{ fontSize:14,fontWeight:500,color:w.text,margin:"0 0 12px" }}>History</h3>
          {allWeeks.slice(0,8).map(wk=>{
            const wkDates=[];const mon=new Date(wk);
            for(let i=0;i<7;i++){const d=new Date(mon);d.setDate(mon.getDate()+i);wkDates.push(d.toISOString().slice(0,10));}
            const score=weekScore(tracker[wk],wkDates);
            return (
              <div key={wk} onClick={()=>{setHistoryWeek(wk);setView("history");}} style={{ background:w.bg,border:`0.5px solid ${w.border}`,borderRadius:10,padding:"12px 16px",marginBottom:8,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center" }}
                onMouseEnter={e=>e.currentTarget.style.borderColor=gold}
                onMouseLeave={e=>e.currentTarget.style.borderColor=w.border}>
                <span style={{ fontSize:13,color:w.text }}>Week of {wk}</span>
                <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                  <div style={{ width:60,height:6,background:w.bg3,borderRadius:3,overflow:"hidden" }}><div style={{ height:"100%",width:`${score}%`,background:gold,borderRadius:3 }} /></div>
                  <span style={{ fontSize:13,fontWeight:500,color:gold,minWidth:36 }}>{score}%</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
